<template>
	<div class="fixed-bottom">
		<div class="container">
			<b-row align-v="center">
				<b-col cols="7">
					© {{ $t('Copyright') }} {{ new Date() | niceDate('YYYY') }} {{ $t('HP Development Company, L.P.') }}
				</b-col>
				<b-col cols="1">
					<a v-t="'Privacy'" href="http://www.hp.com/go/privacy" />
				</b-col>
				<b-col cols="2">
					<a v-t="'Terms & Conditions'" href="http://www.hp.com/go/termsofuse" />
				</b-col>
				<b-col cols="2">
					<b-dropdown ref="languageDropdown" size="sm" variant="link" right class="user-dropdown dropup">
						<template #button-content>
							{{ languages.find(el => el.code === lang).name }}
						</template>
						<button
							v-for="(languageOption, i) in languages"
							:key="i"
							role="menuitem"
							type="button"
							class="dropdown-item"
							:class="{ active: languageOption.code === lang }"
							@click="onLanguagesSelection(languageOption)"
							v-text="languageOption.name"
						/>
					</b-dropdown>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

const niceDate = (d, format = 'MMM Do YYYY  H:mm:ss') => moment(d).format(format);

export default {
	name: 'Footer',
	filters: { niceDate },
	computed: {
		...mapGetters('lang', ['lang', 'languages'])
	},
	methods: {
		...mapActions('lang', ['setLanguage', 'loadLanguage']),
		async onLanguagesSelection(lang) {
			this.$refs.languageDropdown.hide();
			await this.setLanguage(lang.code);
			await this.$router.push({ name: this.$route.name, query: { ...this.$route.query, locale: this.lang } });
			await this.loadLanguage({ lang: this.lang });
		}
	}
};
</script>

<style lang="scss">
$of-color-white: #ffffff !default;
$of-color-dark: #3a3f51 !default;
$of-color-hp-brand: #0088d3 !default;
$of-color-aqua: #23b7e5 !default;
.fixed-bottom {
	background-color: $of-color-white;
	font-size: 14px;
	padding: 20px 20px;
	line-height: 25px;
	margin: 0 -15px;

	a {
		color: $of-color-aqua;
	}

	a:hover {
		text-decoration: none;
	}
}
.dropdown-toggle {
	color: $of-color-dark !important;
}
.dropdown-item.active {
	background: $of-color-aqua !important;
}
</style>
